import React, { useState, useCallback, useEffect } from 'react';

import CloseIcon from "../../assets/images/close.png";

import { connect } from "react-redux";
import { compose } from "redux";

import { Disable } from 'react-disable';
import debounce from "lodash/debounce";

import { updateDepartment, addProcedure, addAttachment, editProcedure, getProcedures } from "../../store/actions/departmentActions";

import Select from 'react-select'




const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};


const probabilityOption = (props) => {
    const { innerRef, innerProps, data } = props;
    return (
        <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center', padding: 10 }}>
            <div style={{ width: 20, height: 20, marginRight: 10, backgroundColor: data.color, color: data.color, borderRadius: 5 }} />
            {data.label}
        </div>
    );
};

const probabilitySingleValue = (props) => {
    const { data } = props;
    return (
        <div style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
            <div style={{ width: 10, height: 10, marginRight: 5, backgroundColor: data.color, color: data.color, borderRadius: 5 }} />
            {data.label === "Almost Certain" || data.label === "Catastrophe" || data.label === "Not started" ? `${data.label.substring(0, 7)}...` : data.label}
        </div>
    );
};


const DepartmentOverlay = ({ close, department, edit, updateDepartmentFN, department_redux, addProcedureFN, addAttachmentFN, editProcedureFN, getProceduresFN }) => {


    const [isLoading, setIsLoading] = useState(false);

    const listRiskAppetites = [{ value: 'Averse', label: 'Averse', color: "#0081A7" }, { value: 'Minimalist', label: 'Minimalist', color: "#00AFB9" }, { value: 'Cautious', label: 'Cautious', color: "#FED9B7" }, { value: 'Open', label: 'Open', color: "#D6606E" }, { value: 'Hungry', label: 'Hungry', color: "#BB133E" }];
    const department_colors = [
        { value: '#FF5733', label: 'Red Orange', color: "#FF5733" },
        { value: '#33FF57', label: 'Green', color: "#33FF57" },
        { value: '#3357FF', label: 'Blue', color: "#3357FF" },
        { value: '#F1C40F', label: 'Yellow', color: "#F1C40F" },
        { value: '#8E44AD', label: 'Purple', color: "#8E44AD" },
        { value: '#E67E22', label: 'Carrot', color: "#E67E22" },
        { value: '#2ECC71', label: 'Emerald', color: "#2ECC71" },
        { value: '#3498DB', label: 'Peter River', color: "#3498DB" },
        { value: '#9B59B6', label: 'Amethyst', color: "#9B59B6" },
        { value: '#34495E', label: 'Wet Asphalt', color: "#34495E" }
    ];
    const [policies, setPolicies] = useState([]);

    const [formControlState, setFormControlState] = useState([]);

    const [currentPolicy, setCurrentPolicy] = useState(null);
    const fileInputRef = React.useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && currentPolicy) {
            //setAddedNew(true);
            addAttachmentFN(department.department_id, currentPolicy.policy_id, file);
        }
    };


    const handleAttachmentClick = (policy) => {

        setCurrentPolicy(policy);

        ////console.log(policy);
        if (policy.policy_attachment) {
            window.open(policy.policy_attachment, '_blank');
        } else {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
        }
    };


    const [formState, setFormState] = useState({
        name: department ? department.name : '',
        definition: department ? department.definition : '',
        personnel_number: department ? department.personnel_number : '',
        risk_appetite: department ? department.risk_appetite : '',
        location: department ? department.location : '',
        color: department ? department.color : '',
        comments: ''
    });





    useEffect(() => {
        if (department) {
            setPolicies([]);
            getProceduresFN(department.department_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const handleChange = (data) => {
        ////console.log(data);
        setFormState(data);
        updateServerData(data, department.department_id, "department");
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateServerData = useCallback(
        debounce((data, department_id, type) => {
            // Make your API call here
            //alert(action_id);
            setIsLoading(true);
            updateDepartmentFN(department_id, data);

            //alert("Sending data to server!!");
            // axios.post("/update-data", data); 
        }, 1500), // Adjust the debounce delay (1000 ms = 1 second)

        []
    );


    useEffect(() => {
        if (department) {
            //let this_department = department.find(department => department.department_id === department.department_id);
            ////console.log(1, department);

            setPolicies(department.policies);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [department]);

    //const [addedNew, setAddedNew] = useState(false);




    const handleChangePolicy = (data, policy_id) => {

        // ////console.log(data);
        setFormControlState(data);

        //update the control details by control_id instead of index 
        let updatedPolicy = data.find(policy => policy.policy_id === policy_id);
        updateServerData2(updatedPolicy, department.department_id, "policy", policy_id);


    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateServerData2 = useCallback(
        debounce((data, department_id, type, policy_id) => {
            // Make your API call here
            //alert(action_id);
            setIsLoading(true);
            editProcedureFN(department_id, policy_id, data);



            //alert("Sending data to server!!");
            // axios.post("/update-data", data); 
        }, 1500), // Adjust the debounce delay (1000 ms = 1 second)
        []
    );


    useEffect(() => {
        if (department_redux) {
            //////console.log(department_redux);
            let this_department = department_redux.find(departmentx => departmentx.department_id === department.department_id);
            //////console.log(2, this_department);

            /* if (this_department && this_department.policies && addedNew) {
                 //alert(1);
                 setPolicies(this_department.policies);
             }*/
            setFormControlState([]);
            this_department && this_department.policies.map(policy => {


                let newpolicy = {
                    ...policy,
                    //policy_details: newpolicy_details
                };

                return setFormControlState(prevState => [...prevState, newpolicy]);

            });


            //setFormState(department_redux);
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [department_redux]);


    return (
        <Disable disabled={isLoading}>
            <div className="p-6 bg-white rounded-lg shadow-2xl">

                {/* Title and Definition */}
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-1xl font-semibold text-[#3b3b3b]">New Department</h1>
                    <img src={CloseIcon} alt="Close" className="w-8 h-8 cursor-pointer" onClick={close} />
                </div>
                <div className="mb-6">
                    <input
                        type="text"
                        placeholder="Name"
                        className="w-full p-3 border border-gray-300 rounded mb-4 bg-[#EEF0ED] text-black"
                        value={formState.name}
                        onChange={(e) => handleChange({ ...formState, name: e.target.value })}
                        name="name"
                    />
                    <textarea
                        placeholder="Definition"
                        className="w-full p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black"
                        value={formState.definition}
                        onChange={(e) => handleChange({ ...formState, definition: e.target.value })}
                        name="definition"
                    />
                </div>

                {/* Risk Owner, Department, Status, Definition Date */}
                <div className="grid grid-cols-4 gap-3 mb-6">
                    {/* <input
                        type="text"
                        placeholder="Personnel Number"
                        className="p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black h-10"
                        value={formState.personnel_number}
                        onChange={(e) => handleChange({ ...formState, personnel_number: e.target.value })}
                        name="personnel_number"
                    /> */}
                    {/*<input
                        type="text"
                        placeholder="Risk Appetite"
                        className="p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black h-10"
                        value={formState.risk_appetite}
                        onChange={handleChange}
                        name="risk_appetite"
                    />*/}

                    <input
                        type="text"
                        placeholder="Location"
                        className="p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black h-10"
                        value={formState.location}
                        onChange={(e) => handleChange({ ...formState, location: e.target.value })}
                        name="location"
                    />

                    <Select
                        options={listRiskAppetites}
                        placeholder="Risk Appetite"
                        onChange={(e) => handleChange({ ...formState, risk_appetite: e.value })}
                        styles={customStyles}
                        components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                        value={listRiskAppetites.find(riskAppetite => riskAppetite.value === formState.risk_appetite)}
                        className="my-custom-select"
                        classNamePrefix="my-custom-select"
                    />

                    <Select
                        options={department_colors}
                        placeholder="Color"
                        onChange={(e) => handleChange({ ...formState, color: e.value })}
                        styles={customStyles}
                        components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                        value={department_colors.find(color => color.value === formState.color)}
                        className="my-custom-select"
                        classNamePrefix="my-custom-select"
                    />




                </div>




                {/* <div className="mb-4 flex justify-between items-center">

                    {formControlState && formControlState.length > 0 && <h3 className="font-semibold mb-2 text-[#3b3b3b]">Policies & Procedures</h3>}


                    <button className="bg-[#3b3b3b] text-white py-2 px-4 rounded hover:bg-opacity-70" onClick={() => { addProcedureFN(department.department_id); }}>Add New Procedure</button>

                </div> */}


                {formControlState && formControlState.length > 0 && <div className="table w-full mb-6 border border-gray-300 rounded-lg bg-[#EEF0ED]">
                    <div className="table-row bg-[#EEF0ED]">
                        <div className="table-cell p-4 border-b border-gray-300 font-semibold">Number</div>
                        <div className="table-cell p-4 border-b border-gray-300 font-semibold">Details</div>
                        <div className="table-cell p-4 border-b border-gray-300 font-semibold">Attachment</div>

                    </div>
                    {formControlState && formControlState.map((policy, index) => (
                        <div className="table-row bg-white">
                            <div className="table-cell p-4 border-b border-gray-300">
                                <span className="font-semibold">{policy.policy_no}</span>
                            </div>
                            <div className="table-cell p-4 border-b border-gray-300">


                                <input
                                    type="text"
                                    value={formControlState.find(c => c.policy_id === policy.policy_id)?.policy_details || ''}
                                    className='w-[250px] p-2'
                                    onChange={(e) => {
                                        const policy_id = policy.policy_id;
                                        const updatedPolicies = [...formControlState];
                                        //update the control details by control_id instead of index
                                        const policyToUpdate = updatedPolicies.find(p => p.policy_id === policy_id);
                                        if (policyToUpdate) {
                                            policyToUpdate.policy_details = e.target.value;
                                        }

                                        handleChangePolicy(updatedPolicies, policy_id);
                                    }}
                                />

                            </div>


                            <div className="table-cell p-4 border-b border-gray-300">
                                <button onClick={() => handleAttachmentClick(policy)} className="text-blue-500 hover:bg-opacity-70">{policy.policy_attachment ? "View Attachment" : "No Attachment"}</button>
                            </div>
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />

                           

                        </div>

                    ))}
                </div>}






                {/*<div className="bg-[#EEF0ED] p-4 rounded-[5px] text-gray-600 mb-2">
                    <div className="flex justify-between">
                        <span className="font-semibold">Mark Jones:</span>
                        <span>10/06/2024 10:12:11pm</span>
                    </div>
                    <p className="mt-2">This is a procedure</p>
                </div>*/}
            </div>
        </Disable>
    );
};



const mapStateToProps = (state) => {
    return {
        department_redux: state.department.policies
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateDepartmentFN: (department_id, data) => dispatch(updateDepartment(department_id, data)),
        addProcedureFN: (department_id, data) => dispatch(addProcedure(department_id, data)),
        addAttachmentFN: (department_id, policy_id, file) => dispatch(addAttachment(department_id, policy_id, file)),
        editProcedureFN: (department_id, policy_id, policy) => dispatch(editProcedure(department_id, policy_id, policy)),
        getProceduresFN: (department_id) => dispatch(getProcedures(department_id))
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(DepartmentOverlay);